import bboxPolygon from '@turf/bbox-polygon'
import { LngLatBounds } from 'mapbox-gl'
import intersect from '@turf/intersect'
import { ICoordinates } from '@monopolio-ui/types-library'

export const CDMX_PROPERTIES = {
  id: '09',
  alias: 'Ciudad de México',
  cleanAlias: 'Ciudad-de-Mexico',
  lng: -99.1394,
  lat: 19.2769,
}

export const getMapBounds = (params: { map: mapboxgl.Map }): number[][] => {
  const { map } = params
  const bounds = map.getBounds()

  if (!bounds) {
    return []
  }

  const mapBoundsPolygon = bboxPolygon([
    bounds.getWest(),
    bounds.getSouth(),
    bounds.getEast(),
    bounds.getNorth(),
  ])

  return mapBoundsPolygon?.geometry?.coordinates[0]
}

export function checkBoundsIntersects(params: {
  mapBounds: LngLatBounds | undefined
  tileBounds: [number, number, number, number]
}): boolean {
  const { mapBounds, tileBounds } = params

  if (!mapBounds) {
    return false
  }

  const mapBoundsPolygon = bboxPolygon([
    mapBounds.getWest(),
    mapBounds.getSouth(),
    mapBounds.getEast(),
    mapBounds.getNorth(),
  ])

  const tileBoundsPolygon = bboxPolygon([
    tileBounds[0],
    tileBounds[1],
    tileBounds[2],
    tileBounds[3],
  ])

  const intersects =
    intersect({
      type: 'FeatureCollection',
      features: [mapBoundsPolygon, tileBoundsPolygon],
    }) != null
  return intersects
}

export const getQuickLinkState = (
  searchAddress?: string,
  coords?: ICoordinates
) => {
  let quickLinkState
  if (coords) {
    if (
      coords?.latitude === CDMX_PROPERTIES.lat &&
      coords?.longitude === CDMX_PROPERTIES.lng
    ) {
      return 'cdmx'
    }
  }
  if (searchAddress) {
    quickLinkState =
      isInsideCDMXfromSearchString(searchAddress) === true ? 'cdmx' : undefined
  }
  return quickLinkState
}
export const isInsideCDMXfromSearchString = (searchString: string) => {
  return String(searchString).toUpperCase().includes('CDMX')
}
